import { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'

/**
 * gogrov.com/r/<code>: remembers the code on this device and goes on to
 * signup. The code travels in the signup metadata and is redeemed there.
 */
export function ReferralLanding() {
  const { code } = useParams<{ code: string }>()
  const clean = (code ?? '').toLowerCase().replace(/[^a-z0-9-]/g, '').slice(0, 32)
  useEffect(() => {
    if (clean.length < 3) return
    try { localStorage.setItem('gg_referral', JSON.stringify({ code: clean, at: Date.now() })) } catch { /* private mode */ }
  }, [clean])
  return <Navigate to="/signup" replace />
}
